import React, { useState, useEffect } from "react";
import { Field, useFormikContext, useFormik, FormikProvider } from "formik";
// import { Col, Row } from "react-bootstrap";
import { Button, Col, Form, Row, Modal } from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomMultiSelect from "../../../CustomControls/CustomMultiSelect";
import {
  POST_GetCategoryDropDownListByCategoryType,
  POST_GetDepartmentDropDownList,
} from "../../../helpers/url_helper";
import { post } from "../../../helpers/api_helper";
import { Link } from "react-router-dom";
import { warningMessage } from "../CommonFunctions";
import * as Yup from "yup";
import { Spin } from "antd";

import CustomSelect from "../../../CustomControls/CustomSelect";

// const CommonTestMasterRate = ({
//   ListOfTestDepartments,
//   RewiseType,
//   departmentOptions,
//   EffectiveDateID,
//   formik,
//   effectiveDateOptions,
//   TestMasterRateType,
//   CustomerIDEncrypt,
// }) => {
const CommonTestMasterRate = () => {
  const { values, setFieldValue } = useFormikContext();

  const [isLoading, setIsLoading] = useState(false);
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);

  useEffect(() => {
    getDepartmentList();
    getUnitDDL();
  }, []);

  const getUnitDDL = async () => {
    // setIsLoading(true);
    post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 8, //Unit
      ParentCategoryID: 0,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setUnitOptions(
            response?.List?.map((item) => ({
              label: item?.CategoryName,
              value: item?.CategoryID,
            }))
          );
        }
        // setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  const getDepartmentList = async () => {
    setIsLoading(true);
    await post(POST_GetDepartmentDropDownList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setDepartmentOptions(
            response?.List?.map((item) => ({
              label: item.DepartmentName,
              value: item.DepartmentIDEncrypted,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleChangeSearch = async (TestSearchText) => {
    const newFinalList = values.ListOfTestDepartments?.map((department) => {
      const anyTestMatches = department?.ListOfTest?.some((test) =>
        test?.TestName?.toLowerCase().includes(TestSearchText?.toLowerCase())
      );

      // Update the department and its tests
      return {
        ...department,
        display: anyTestMatches ? true : false,
        ListOfTest: department?.ListOfTest?.map((test) => {
          if (
            test?.TestName?.toLowerCase().includes(
              TestSearchText?.toLowerCase()
            )
          ) {
            return { ...test, display: true };
          } else {
            return { ...test, display: false };
          }
        }),
      };
    });

    //   console.log("List", newFinalList);

    setFieldValue("ListOfTestDepartments", newFinalList);
  };

  const handleChangeDepartmentSearch = async (selectedDepartments) => {
    if (selectedDepartments?.length > 0) {
      const selectedDepartmentIDs = selectedDepartments.map((dep) => dep.value);

      const newFinalList = values.ListOfTestDepartments?.map((department) => {
        if (selectedDepartmentIDs.includes(department?.DepartmentIDEncrypt)) {
          return { ...department, display: true };
        } else {
          return { ...department, display: false };
        }
      });

      //console.log("LIst", newFinalList);

      setFieldValue("ListOfTestDepartments", newFinalList);
    } else {
      setFieldValue(
        "ListOfTestDepartments",
        values?.ListOfTestDepartments?.map((item) => ({
          DepartmentIDEncrypt: item?.DepartmentIDEncrypt,
          DepartmentName: item?.DepartmentName,
          display: true,
          ListOfTest: item?.ListOfTest?.map((itemsub) => ({
            TestMasterRateIDEncrypt: itemsub?.TestMasterRateIDEncrypt,
            TestMasterIDEncrypt: itemsub?.TestMasterIDEncrypt,
            TestName: itemsub?.TestName,
            TestRate: itemsub?.TestRate,
            EffectiveDate: itemsub?.EffectiveDate,
            display: true,
            ListOfTestParameter: itemsub?.ListOfTestParameter,
            ListOfMoreTestRates: itemsub?.ListOfMoreTestRates,
          })),
        }))
      );
    }
  };

  const [showDefineMoreRatesModal, setShowDefineMoreRatesModal] =
    useState(false);

  const RateTypeOptions = [
    { label: "Upto Element", value: 1 },
    { label: "Indentification of Material", value: 2 },
    { label: "Purity of Material", value: 3 },
    { label: "Based on Measurement", value: 4 },
    { label: "With Photo", value: 5 },
    { label: "Onsite Testing", value: 6 },
    { label: "Based On Hrs.", value: 7 },
  ];

  let initialMoreTestRatesList = {
    TestMasterDefineMoreRatesIDEncrypt: "",
    TestMasterIDEncrypt: "",
    RateType: "",
    Unit: "",
    MinValue: "",
    MaxValue: "",
    TestRate: "",
    IsDeleted: false,
    IsIncudeStandardRate: false,
  };

  const getDefineMoreRatesDetail = async (index, indexsub) => {
    formikDefineMoreRates.setFieldValue("TestListIndex", index);
    formikDefineMoreRates.setFieldValue("TestListIndexSub", indexsub);

    let updatedList = [...values.ListOfTestDepartments];

    let testRatesList = updatedList[index]?.ListOfTest[
      indexsub
    ]?.ListOfMoreTestRates?.filter((x) => x.IsDeleted == false)?.map(
      (item) => ({
        ...item,
        IsDeleted: item?.RateType == "" ? true : false,
      })
    );

    // Update MoreTestRatesList in formik
    if (testRatesList?.filter((x) => x.IsDeleted == false)?.length == 0) {
      formikDefineMoreRates.setFieldValue("MoreTestRatesList", [
        ...testRatesList,
        initialMoreTestRatesList,
      ]);
    } else {
      formikDefineMoreRates.setFieldValue("MoreTestRatesList", testRatesList);
    }

    const firstItem =
      updatedList[index]?.ListOfTest[indexsub]?.ListOfMoreTestRates?.[0];

    if (firstItem) {
      formikDefineMoreRates.setFieldValue(
        "IsIncudeStandardRate",
        firstItem ? firstItem.IsIncudeStandardRate : false
      );
    } else {
      formikDefineMoreRates.setFieldValue("IsIncudeStandardRate", false);
    }

    setShowDefineMoreRatesModal(true);
  };

  const validationSchemaDefineMoreRates = Yup.object().shape({});

  const formikDefineMoreRates = useFormik({
    validationSchema: validationSchemaDefineMoreRates,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitDefineMoreRates(values, formikHelpers),
    initialValues: {
      MoreTestRatesList: [initialMoreTestRatesList],
      IsIncudeStandardRate: false,
      TestListIndex: -1,
      TestListIndexSub: -1,
      isDuplicate: false,
    },
    validateOnBlur: false,
  });

  const {
    values: { MoreTestRatesList, IsIncudeStandardRate },
  } = formikDefineMoreRates;

  const handleValidSubmitDefineMoreRates = async (values) => {
    if (values?.isDuplicate) {
      return;
    }

    if (
      values?.MoreTestRatesList?.filter((x) => x?.RateType > 0).length === 0
    ) {
      warningMessage("atleast one Rate Type select to add.");
      return true;
    }
    // Get the list of valid test rates (not deleted)
    const validRates = values?.MoreTestRatesList?.filter(
      (x) => x?.IsDeleted === false
    );

    // // Check required fields for RateTypes 1, 4, and 7
    // const hasMissingFields = validRates?.some((x) => {
    //   if (x?.RateType === 4 && (!x?.Unit || x?.MinValue === "")) {
    //     warningMessage(
    //       "Unit and Min Value are required for Rate Type Based on Measurement."
    //     );
    //     return true;
    //   }
    //   if ((x?.RateType === 1 || x?.RateType === 7) && x?.MinValue === "") {
    //     warningMessage("Min Value is required for the selected Rate Type.");
    //     return true;
    //   }
    //   return false;
    // });

    // if (hasMissingFields) {
    //   return;
    // }
    const hasMissingFields = validRates?.some((x) => {
      if (x?.RateType === 4 && (!x?.Unit || (!x?.MinValue && !x?.MaxValue))) {
        warningMessage(
          "Unit and at least one of Min/Max Value are required for Rate Type Based on Measurement."
        );
        return true;
      }
      if (
        (x?.RateType === 1 || x?.RateType === 7) &&
        !x?.MinValue &&
        !x?.MaxValue
      ) {
        warningMessage(
          "At least one of Min/Max Value is required for the selected Rate Type."
        );
        return true;
      }
      return false;
    });

    if (hasMissingFields) {
      return;
    }

    // // const rateTypeGroups = {}; // Store min-max ranges for each RateType

    // // let isOverlapping = false;

    // // validRates.forEach((item) => {
    // //   if ([1, 4, 7].includes(item.RateType)) {
    // //     const { RateType, MinValue, MaxValue } = item;
    // //     if (!rateTypeGroups[RateType]) {
    // //       rateTypeGroups[RateType] = [];
    // //     }

    // //     // Check if new range overlaps with existing ranges
    // //     for (const range of rateTypeGroups[RateType]) {
    // //       if (
    // //         (MinValue >= range.MinValue && MinValue <= range.MaxValue) || // MinValue inside an existing range
    // //         (MaxValue >= range.MinValue && MaxValue <= range.MaxValue) || // MaxValue inside an existing range
    // //         (MinValue < range.MinValue && MaxValue > range.MaxValue) // New range completely covers an existing range
    // //       ) {
    // //         isOverlapping = true;
    // //         return;
    // //       }
    // //     }

    // //     // Store the new valid range
    // //     rateTypeGroups[RateType].push({ MinValue, MaxValue });
    // //   }
    // // });

    // // if (isOverlapping) {
    // //   warningMessage(`Overlapping Min/Max values !`);
    // //   return;
    // // }
    // const rateTypeGroups = {}; // Store min-max ranges for each RateType

    // let isOverlapping = false;

    // validRates.forEach((item) => {
    //   if ([1, 4, 7].includes(item.RateType)) {
    //     const { RateType } = item;
    //     const MinValue = parseFloat(item.MinValue); // Convert to number
    //     const MaxValue = parseFloat(item.MaxValue);
    //     const Unit = item.Unit || "default"; // Use 'default' if Unit is empty (only needed for RateType 4)

    //     // Handle RateType 4 separately (grouped by Unit)
    //     if (RateType === 4) {
    //       if (!rateTypeGroups[RateType]) {
    //         rateTypeGroups[RateType] = {};
    //       }
    //       if (!rateTypeGroups[RateType][Unit]) {
    //         rateTypeGroups[RateType][Unit] = [];
    //       }

    //       // Check overlap for the same Unit
    //       for (const range of rateTypeGroups[RateType][Unit]) {
    //         if (
    //           (MinValue >= range.MinValue && MinValue <= range.MaxValue) || // Min inside existing range
    //           (MaxValue >= range.MinValue && MaxValue <= range.MaxValue) || // Max inside existing range
    //           (MinValue < range.MinValue && MaxValue > range.MaxValue) // New range fully covers existing range
    //         ) {
    //           isOverlapping = true;
    //           console.log("Overlap found: ", {
    //             RateType,
    //             Unit,
    //             MinValue,
    //             MaxValue,
    //             existingRange: range,
    //           });
    //           return;
    //         }
    //       }

    //       // Store only unique Min/Max ranges per Unit
    //       if (
    //         !rateTypeGroups[RateType][Unit].some(
    //           (r) => r.MinValue === MinValue && r.MaxValue === MaxValue
    //         )
    //       ) {
    //         rateTypeGroups[RateType][Unit].push({ MinValue, MaxValue });
    //       }
    //     } else {
    //       // For RateTypes 1 and 7 (without Unit)
    //       if (!rateTypeGroups[RateType]) {
    //         rateTypeGroups[RateType] = [];
    //       }

    //       // Check overlap for RateTypes 1 & 7
    //       for (const range of rateTypeGroups[RateType]) {
    //         if (
    //           (MinValue >= range.MinValue && MinValue <= range.MaxValue) ||
    //           (MaxValue >= range.MinValue && MaxValue <= range.MaxValue) ||
    //           (MinValue < range.MinValue && MaxValue > range.MaxValue)
    //         ) {
    //           isOverlapping = true;
    //           console.log("Overlap found: ", {
    //             RateType,
    //             MinValue,
    //             MaxValue,
    //             existingRange: range,
    //           });
    //           return;
    //         }
    //       }

    //       // Store only unique Min/Max ranges
    //       if (
    //         !rateTypeGroups[RateType].some(
    //           (r) => r.MinValue === MinValue && r.MaxValue === MaxValue
    //         )
    //       ) {
    //         rateTypeGroups[RateType].push({ MinValue, MaxValue });
    //       }
    //     }
    //   }
    // });

    // if (isOverlapping) {
    //   warningMessage(`Overlapping Min/Max values!`);
    //   return;
    // }

    // Check for duplicate entries

    const rateTypeGroups = {}; // Store min-max ranges for each RateType
    let isOverlapping = false;

    validRates.forEach((item) => {
      if ([1, 4, 7].includes(item.RateType)) {
        const { RateType } = item;
        const MinValue = item.MinValue !== "" ? parseFloat(item.MinValue) : 0;
        const MaxValue =
          item.MaxValue !== "" ? parseFloat(item.MaxValue) : Infinity;
        const Unit = item.Unit || "default"; // Use 'default' if Unit is empty (only for RateType 4)

        if (RateType === 4) {
          if (!rateTypeGroups[RateType]) {
            rateTypeGroups[RateType] = {};
          }
          if (!rateTypeGroups[RateType][Unit]) {
            rateTypeGroups[RateType][Unit] = [];
          }

          for (const range of rateTypeGroups[RateType][Unit]) {
            if (
              (MinValue !== null &&
                MinValue >= range.MinValue &&
                MinValue <= range.MaxValue) || // Min inside existing range
              (MaxValue !== null &&
                MaxValue >= range.MinValue &&
                MaxValue <= range.MaxValue) || // Max inside existing range
              (MinValue !== null &&
                MaxValue !== null &&
                MinValue <= range.MinValue &&
                MaxValue >= range.MaxValue) || // New range fully covers existing range
              (MinValue === null &&
                MaxValue !== null &&
                MaxValue > range.MinValue) || // Only MaxValue exists, overlaps with an existing MinValue
              (MaxValue === null &&
                MinValue !== null &&
                MinValue <= range.MaxValue) // Only MinValue exists, overlaps with an existing MaxValue
            ) {
              isOverlapping = true;
              return;
            }
          }

          rateTypeGroups[RateType][Unit].push({ MinValue, MaxValue });
        } else {
          if (!rateTypeGroups[RateType]) {
            rateTypeGroups[RateType] = [];
          }

          for (const range of rateTypeGroups[RateType]) {
            if (
              (MinValue !== null &&
                MinValue >= range.MinValue &&
                MinValue <= range.MaxValue) || // Min inside existing range
              (MaxValue !== null &&
                MaxValue >= range.MinValue &&
                MaxValue <= range.MaxValue) || // Max inside existing range
              (MinValue !== null &&
                MaxValue !== null &&
                MinValue <= range.MinValue &&
                MaxValue >= range.MaxValue) || // New range fully covers existing range
              (MinValue === null &&
                MaxValue !== null &&
                MaxValue > range.MinValue) || // Only MaxValue exists, overlaps with an existing MinValue
              (MaxValue === null &&
                MinValue !== null &&
                MinValue <= range.MaxValue) // Only MinValue exists, overlaps with an existing MaxValue
            ) {
              isOverlapping = true;
              return;
            }
          }

          rateTypeGroups[RateType].push({ MinValue, MaxValue });
        }
      }
    });

    if (isOverlapping) {
      warningMessage(`Overlapping Min/Max values!`);
      return;
    }

    // const uniqueEntries = new Set();
    // let isDuplicate = false;

    // validRates.forEach((item) => {
    //   const key =
    //     item.RateType === 1 || item.RateType === 4 || item.RateType === 7
    //       ? `${item.RateType}-${item.MinValue}-${item.MaxValue}-${parseFloat(
    //           item.TestRate
    //         )}`
    //       : `${item.RateType}`;

    //   if (uniqueEntries.has(key)) {
    //     isDuplicate = true;
    //   } else {
    //     uniqueEntries.add(key);
    //   }
    // });

    // if (isDuplicate) {
    //   warningMessage("Duplicate rate details found!");
    //   return;
    // }

    const uniqueEntries = new Set();
    let isDuplicate = false;

    validRates.forEach((item) => {
      const key =
        item.RateType === 4
          ? `${item.RateType}-${item.Unit}-${item.MinValue}-${
              item.MaxValue
            }-${parseFloat(item.TestRate)}`
          : item.RateType === 1 || item.RateType === 7
          ? `${item.RateType}-${item.MinValue}-${item.MaxValue}-${parseFloat(
              item.TestRate
            )}`
          : `${item.RateType}`;

      if (uniqueEntries.has(key)) {
        isDuplicate = true;
      } else {
        uniqueEntries.add(key);
      }
    });

    if (isDuplicate) {
      warningMessage("Duplicate rate details found!");
      return;
    }

    const hasMissingTestRate = validRates?.some(
      (x) => x?.RateType && !parseFloat(x?.TestRate)
    );

    if (
      values?.IsIncudeStandardRate &&
      validRates?.filter(
        (x) =>
          x?.IsDeleted === false &&
          x?.RateType !== "" &&
          parseFloat(x?.TestRate)
      ).length === 0
    ) {
      warningMessage(
        "At least one Rate entry is required when 'Include Standard Rate' is selected."
      );
      return;
    }

    if (hasMissingTestRate) {
      warningMessage("Test Rate is required when Rate Type is selected.");
      return;
    }
    // Check if MinValue is greater than MaxValue
    const hasInvalidRange = validRates?.some(
      (x) =>
        x?.MinValue !== "" &&
        x?.MaxValue !== "" &&
        parseFloat(x?.MinValue) > parseFloat(x?.MaxValue)
    );

    if (hasInvalidRange) {
      warningMessage("Min Value cannot be greater than Max Value.");
      return;
    }

    await setFieldValue(
      `ListOfTestDepartments.[${values?.TestListIndex}].ListOfTest.[${values?.TestListIndexSub}].ListOfMoreTestRates`,
      values?.MoreTestRatesList?.map((itemsubRate) => ({
        TestMasterDefineMoreRatesIDEncrypt:
          itemsubRate?.TestMasterDefineMoreRatesIDEncrypt,
        TestMasterIDEncrypt: itemsubRate?.TestMasterIDEncrypt,
        RateType: itemsubRate?.RateType,
        Unit: itemsubRate?.Unit,
        MinValue: itemsubRate?.MinValue,
        MaxValue: itemsubRate?.MaxValue,
        TestRate: itemsubRate?.TestRate,
        IsDeleted: itemsubRate?.IsDeleted,
        IsIncudeStandardRate: values?.IsIncudeStandardRate,
      }))
    );

    setShowDefineMoreRatesModal(false);
  };

  const addDefineMoreRates = (indxTest) => {
    formikDefineMoreRates.setFieldValue(`MoreTestRatesList`, [
      ...MoreTestRatesList,
      initialMoreTestRatesList,
    ]);
  };

  const removeMoreRates = (indxTest) => {
    let newList = MoreTestRatesList?.filter((x) => x?.IsDeleted == false)?.map(
      (item, idx) => {
        if (indxTest == idx) {
          return {
            ...item,
            IsDeleted: true,
          };
        } else {
          return { ...item };
        }
      }
    );

    formikDefineMoreRates.setFieldValue("MoreTestRatesList", newList);
  };

  const checkValidationMoreRates = (index) => {
    const currentItem = MoreTestRatesList[index];

    if (!currentItem) return;

    // Check if any of the fields are blank, then skip validation
    if (!currentItem.RateType || currentItem.TestRate === "") {
      return;
    }

    // // const isDuplicate = MoreTestRatesList.some((item, i) => {
    // //   if (i === index || item.IsDeleted) return false; // Exclude the current item itself and deleted items

    // //   // Convert MinValue and MaxValue to numbers for proper comparison
    // //   const currentMinValue = Number(currentItem.MinValue);
    // //   const currentMaxValue = Number(currentItem.MaxValue);
    // //   const itemMinValue = Number(item.MinValue);
    // //   const itemMaxValue = Number(item.MaxValue);

    // //   if (item.RateType === currentItem.RateType) {
    // //     if (
    // //       currentItem.RateType === 1 ||
    // //       currentItem.RateType === 4 ||
    // //       currentItem.RateType === 7
    // //     ) {
    // //       // If RateType is 4 or 7, MinValue and MaxValue should not be repeated
    // //       return (
    // //         currentMinValue === itemMinValue && currentMaxValue === itemMaxValue
    // //       );
    // //     } else {
    // //       // Otherwise, only TestRate should not be duplicated
    // //       return item.RateType === currentItem.RateType;
    // //     }
    // //   }
    // //   return false;
    // // });

    // // if (isDuplicate) {
    // //   formikDefineMoreRates.setFieldValue("isDuplicate", true);
    // //   warningMessage("Duplicate rate details found!");

    // //   // Reset the duplicated values
    // //   formikDefineMoreRates.setFieldValue(
    // //     `MoreTestRatesList[${index}].RateType`,
    // //     ""
    // //   );
    // //   formikDefineMoreRates.setFieldValue(
    // //     `MoreTestRatesList[${index}].MinValue`,
    // //     ""
    // //   );
    // //   formikDefineMoreRates.setFieldValue(
    // //     `MoreTestRatesList[${index}].MaxValue`,
    // //     ""
    // //   );
    // //   formikDefineMoreRates.setFieldValue(
    // //     `MoreTestRatesList[${index}].TestRate`,
    // //     ""
    // //   );
    // //   return;
    // // } else {
    // //   formikDefineMoreRates.setFieldValue("isDuplicate", false);
    // // }

    const currentMinValue = Number(currentItem.MinValue);
    const currentMaxValue = Number(currentItem.MaxValue);
    const currentRateType = currentItem.RateType;

    let isDuplicate = false;
    let hasOverlappingRange = false;
    let hasSequentialError = false;
    let hasMinMaxError = false;
    let hasMinMaxequalError = false;
    //let previousMaxValue = 0; // Track the last MaxValue for sequence validation

    MoreTestRatesList.forEach((item, i) => {
      if (i === index || item.IsDeleted) return;

      const itemMinValue = Number(item.MinValue);
      const itemMaxValue = Number(item.MaxValue);
      const itemRateType = item.RateType;

      if ([1, 4, 7].includes(currentRateType)) {
        if (currentRateType === itemRateType) {
          // if (
          //   (currentMinValue >= itemMinValue &&
          //     currentMinValue <= itemMaxValue) ||
          //   (currentMaxValue >= itemMinValue &&
          //     currentMaxValue <= itemMaxValue) ||
          //   (currentMinValue < itemMinValue && currentMaxValue > itemMaxValue)
          // ) {
          //   hasOverlappingRange = true;
          // }
          // if (itemMaxValue >= previousMaxValue) {
          //   previousMaxValue = itemMaxValue;
          // }
          // if (currentMinValue <= previousMaxValue) {
          //   hasSequentialError = true;
          // }
          // if (currentMaxValue <= currentMinValue) {
          //   hasMinMaxError = true;
          // }
          if (currentMinValue === currentMaxValue) {
            hasMinMaxequalError = true;
          }
        }
      } else {
        if (currentRateType === itemRateType) {
          isDuplicate = true;
        }
      }
    });

    if (isDuplicate) {
      warningMessage(`Duplicate RateType found!`); //${currentRateType}
      resetInvalidRow(index);
      formikDefineMoreRates.setFieldValue("isDuplicate", true);
      return;
    }

    // if (hasOverlappingRange) {
    //   warningMessage(`Overlapping range detected.`); //${currentRateType}
    //   resetInvalidRow(index);
    //   formikDefineMoreRates.setFieldValue("isDuplicate", true);
    //   return;
    // }

    // if (hasSequentialError) {
    //   warningMessage(`MinValue must start from previous MaxValue .`); //${currentRateType}
    //   resetInvalidRow(index);
    //   formikDefineMoreRates.setFieldValue("isDuplicate", true);
    //   return;
    // }
    // if (hasMinMaxError) {
    //   warningMessage(`MaxValue must be greater than MinValue.`);
    //   resetInvalidRow(index);
    //   formikDefineMoreRates.setFieldValue("isDuplicate", true);
    //   return;
    // }

    if (hasMinMaxequalError) {
      warningMessage(`MinValue and MaxValue cannot be equal!`);
      resetInvalidRow(index);
      formikDefineMoreRates.setFieldValue("isDuplicate", true);
      return;
    }

    formikDefineMoreRates.setFieldValue("isDuplicate", false);
  };

  const resetInvalidRow = (index) => {
    formikDefineMoreRates.setFieldValue(
      `MoreTestRatesList[${index}].MinValue`,
      ""
    );
    formikDefineMoreRates.setFieldValue(
      `MoreTestRatesList[${index}].MaxValue`,
      ""
    );
    formikDefineMoreRates.setFieldValue(
      `MoreTestRatesList[${index}].TestRate`,
      ""
    );
  };

  return (
    <>
      <div className="card mb-2" style={{ height: "auto" }}>
        <div className="card-header p-2">
          <h4 className="card-title">Test Detail</h4>
        </div>
        <div className="p-1">
          <Row>
            <Col lg={3}>
              <Field
                label="Department"
                name="DepartmentIDs"
                placeholder={"Select Department"}
                options={departmentOptions}
                component={CustomMultiSelect}
                isMulti={true}
                // menuPosition="fixed"
                onChange={(selectedOptions) => {
                  setFieldValue("DepartmentIDs", selectedOptions ?? []);
                  handleChangeDepartmentSearch(selectedOptions ?? []);
                }}
              />
            </Col>
            <Col lg={2}>
              <Field
                label="Test"
                name="TestSearch"
                placeholder={"Search Test Name"}
                component={CustomInput}
                maxLength={100}
                noMarginBottom={true}
                style={{ height: "2.2rem" }}
                onChange={(e) => {
                  setFieldValue("TestSearch", e?.target?.value ?? "");
                  handleChangeSearch(e?.target?.value ?? "");
                }}
              />
            </Col>
          </Row>
        </div>

        {/* <div className="card-body p-1">
        <div className="basic-form">
          <div className="card"> */}
        <div className="card-body p-1">
          <div className="table-responsive active-projects style-1 shorting">
            <div
              id="StandardParameters-tbl_wrapper"
              className="dataTables_wrapper table-responsive no-footer "
              style={{ height: "500px", overflowY: "auto" }}
            >
              <table
                id="StandardParameters-tbl"
                className="table dataTable no-footer mb-0 "
              >
                <thead className="fixedheader">
                  <tr>
                    <th width="2%">Sr. No</th>
                    <th width="15%">Department</th>
                    <th width="15%">Test Name</th>
                    <th width="15%">Parameter</th>
                    <th
                      width="15%"
                      style={{
                        textAlign: "left",
                      }}
                    >
                      Rate
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {values?.ListOfTestDepartments?.filter(
                    (x) => x.display == true
                  )?.length > 0 ? (
                    values?.ListOfTestDepartments?.map((item, index) => (
                      <React.Fragment key={index}>
                        {item?.ListOfTest?.filter((x) => x.display == true)
                          ?.length > 0
                          ? item?.ListOfTest?.map((itemSub, indexSub) => (
                              <React.Fragment key={indexSub}>
                                <tr
                                  key={indexSub}
                                  style={{
                                    display:
                                      item?.display === false ||
                                      itemSub?.display === false
                                        ? "none"
                                        : "",
                                  }}
                                >
                                  <td>
                                    {indexSub ==
                                    item?.ListOfTest?.findIndex(
                                      (x) => x.display == true
                                    )
                                      ? index + 1
                                      : ""}
                                  </td>
                                  <td>
                                    {indexSub ==
                                    item?.ListOfTest?.findIndex(
                                      (x) => x.display == true
                                    )
                                      ? item?.DepartmentName
                                      : ""}
                                  </td>
                                  <td>
                                    {itemSub?.TestName}
                                    {"  "}
                                    <Link
                                      to="#"
                                      className="text-primary"
                                      title="Define More Rates"
                                      onClick={() => {
                                        getDefineMoreRatesDetail(
                                          index,
                                          indexSub
                                        );
                                      }}
                                    >
                                      (Define More Rates)
                                    </Link>{" "}
                                  </td>
                                  <td></td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    <Field
                                      type="number"
                                      name={`ListOfTestDepartments.[${index}].ListOfTest.[${indexSub}].TestRate`}
                                      component={CustomInput}
                                      placeholder="Test Rate"
                                      noMarginBottom={true}
                                      disabled={values.RewiseType === 2}
                                      style={{ width: "250px" }}
                                    />
                                  </td>
                                </tr>
                                {itemSub?.ListOfTestParameter?.length > 0
                                  ? itemSub?.ListOfTestParameter?.map(
                                      (itemSubX, indexSubX) => (
                                        <tr
                                          key={indexSubX}
                                          style={{
                                            display:
                                              item?.display === false ||
                                              itemSub?.display === false
                                                ? "none"
                                                : "",
                                          }}
                                        >
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td>{itemSubX?.ParameterName}</td>
                                          <td
                                            style={{
                                              textAlign: "left",
                                            }}
                                          >
                                            <Field
                                              type="number"
                                              name={`ListOfTestDepartments.[${index}].ListOfTest.[${indexSub}].ListOfTestParameter.[${indexSubX}].ParameterRate`}
                                              component={CustomInput}
                                              placeholder="Parameter Rate"
                                              noMarginBottom={true}
                                              disabled={values.RewiseType === 2}
                                              style={{ width: "250px" }}
                                            />
                                          </td>
                                        </tr>
                                      )
                                    )
                                  : ""}
                              </React.Fragment>
                            ))
                          : ""}
                      </React.Fragment>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={8}
                        style={{
                          textAlign: "left",
                        }}
                      >
                        <div>{"No Record Found..."}</div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/* </div>
        </div>
      </div> */}
      </div>
      <Modal
        className="fade"
        show={showDefineMoreRatesModal}
        onHide={setShowDefineMoreRatesModal}
        size="lg"
        backdrop="static"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <FormikProvider value={formikDefineMoreRates}>
            <Form onSubmit={formikDefineMoreRates.handleSubmit}>
              <Modal.Header>
                <Modal.Title>Define More Rates</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowDefineMoreRatesModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body
                className={
                  values?.RewiseType == 1 && values?.IsBackDate == false
                    ? ""
                    : "disableDiv"
                }
              >
                <Row>
                  <Col lg={6}>
                    <div className="me-5">
                      <div className="d-flex mb-2">
                        <label>Include Standard Rate &nbsp;</label>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="flexSwitchCheckIncudeStandardRate"
                            title={IsIncudeStandardRate == true ? "Yes" : "No"}
                            checked={IsIncudeStandardRate}
                            onChange={() => {
                              formikDefineMoreRates.setFieldValue(
                                "IsIncudeStandardRate",
                                !IsIncudeStandardRate
                              );
                            }}
                            style={{ cursor: "pointer" }}
                          ></input>
                        </div>
                      </div>
                    </div>
                    {/* </div> */}
                  </Col>
                </Row>
                <hr className="mt-1 mb-2"></hr>
                <Row>
                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting mb-2">
                      <div
                        id="DefineMoreRates-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="DefineMoreRates-tbl"
                          className="table dataTable no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="4%"></th>
                              <th width="28%">Rate Type</th>
                              <th width="24%">Unit</th>
                              <th width="12%">Min Value</th>
                              <th width="12%">Max Value</th>
                              <th width="20%" style={{ textAlign: "left" }}>
                                Rate
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {MoreTestRatesList?.length > 0 ? (
                              MoreTestRatesList?.map((itemTest, indxTest) => (
                                <tr
                                  key={indxTest}
                                  style={{
                                    display:
                                      itemTest.IsDeleted == true ? "none" : "",
                                  }}
                                >
                                  <td className="p-1">
                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md bg-primary-light"
                                      title="New More Test Rates"
                                      onClick={(e) => {
                                        addDefineMoreRates(indxTest);
                                        e.preventDefault();
                                      }}
                                    >
                                      <i className="fa fa-plus"></i>
                                    </Link>
                                    {MoreTestRatesList?.filter(
                                      (x) => x.IsDeleted == false
                                    )?.length > 1 ? (
                                      <Link
                                        to="#"
                                        className="icon-box icon-box-md bg-danger-light ms-1"
                                        title="Remove More Test Rates"
                                        onClick={(e) => {
                                          removeMoreRates(indxTest);
                                          e.preventDefault();
                                        }}
                                      >
                                        <i className="fa fa-minus"></i>
                                      </Link>
                                    ) : (
                                      ""
                                    )}
                                  </td>

                                  <td
                                    className="p-1"
                                    style={{
                                      minWidth: "150px",
                                    }}
                                  >
                                    <Field
                                      name={`MoreTestRatesList[${indxTest}].RateType`}
                                      placeholder={"Rate Type"}
                                      options={RateTypeOptions}
                                      component={CustomSelect}
                                      noMarginBottom={true}
                                      menuPosition="fixed"
                                      isClearable={false}
                                      onChange={(e) => {
                                        const selectedRateType = e?.value ?? "";
                                        formikDefineMoreRates.setFieldValue(
                                          `MoreTestRatesList[${indxTest}].RateType`,
                                          e?.value ?? ""
                                        );

                                        // If RateType is NOT 4 or 7, clear MinValue & MaxValue
                                        if (
                                          ![1, 4, 7].includes(selectedRateType)
                                        ) {
                                          formikDefineMoreRates.setFieldValue(
                                            `MoreTestRatesList[${indxTest}].MinValue`,
                                            ""
                                          );
                                          formikDefineMoreRates.setFieldValue(
                                            `MoreTestRatesList[${indxTest}].MaxValue`,
                                            ""
                                          );
                                        }
                                        checkValidationMoreRates(indxTest);
                                      }}
                                    />
                                  </td>
                                  <td
                                    className="p-1"
                                    style={{
                                      minWidth: "150px",
                                    }}
                                  >
                                    {itemTest.RateType === 4 ? (
                                      <Field
                                        name={`MoreTestRatesList[${indxTest}].Unit`}
                                        placeholder={"Unit"}
                                        options={unitOptions}
                                        component={CustomSelect}
                                        noMarginBottom={true}
                                        menuPosition="fixed"
                                        isDisabled={
                                          itemTest.RateType === 4 ? false : true
                                        }
                                        onChange={(e) => {
                                          formikDefineMoreRates.setFieldValue(
                                            `MoreTestRatesList[${indxTest}].Unit`,
                                            e?.value ?? ""
                                          );
                                        }}
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                  <td
                                    className="p-1"
                                    style={{
                                      minWidth: "105px",
                                    }}
                                  >
                                    <Field
                                      name={`MoreTestRatesList[${indxTest}].MinValue`}
                                      placeholder={"Min Value"}
                                      component={CustomInput}
                                      type="number"
                                      noMarginBottom={true}
                                      numberTypeWithoutDot={true}
                                      maxLength={5}
                                      disabled={
                                        ![1, 4, 7].includes(itemTest.RateType)
                                      }
                                      onBlur={() =>
                                        checkValidationMoreRates(indxTest)
                                      }
                                    />
                                  </td>
                                  <td
                                    className="p-1"
                                    style={{
                                      minWidth: "105px",
                                    }}
                                  >
                                    <Field
                                      name={`MoreTestRatesList[${indxTest}].MaxValue`}
                                      placeholder={"Max Value"}
                                      component={CustomInput}
                                      type="number"
                                      noMarginBottom={true}
                                      numberTypeWithoutDot={true}
                                      maxLength={5}
                                      disabled={
                                        ![1, 4, 7].includes(itemTest.RateType)
                                      }
                                      onBlur={() =>
                                        checkValidationMoreRates(indxTest)
                                      }
                                    />
                                  </td>

                                  <td
                                    className="p-1"
                                    style={{
                                      textAlign: "left",
                                      minWidth: "150px",
                                    }}
                                  >
                                    <Field
                                      name={`MoreTestRatesList[${indxTest}].TestRate`}
                                      placeholder={"TestRate"}
                                      type="number"
                                      component={CustomInput}
                                      maxLength={10}
                                      noMarginBottom={true}
                                      onBlur={() =>
                                        checkValidationMoreRates(indxTest)
                                      }
                                    />
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan={7}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                {values?.RewiseType == 1 && values?.IsBackDate == false ? (
                  <Button type="submit" variant="primary btn-sm">
                    <i className="fa-solid fa-plus"></i> Add
                  </Button>
                ) : (
                  ""
                )}

                <Button
                  variant="danger btn-sm"
                  onClick={() => setShowDefineMoreRatesModal(false)}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Spin>
      </Modal>
    </>
  );
};

export default CommonTestMasterRate;
